module.exports = __webpack_public_path__ + "static/media/logo.948d118e.png";